var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"agPOSTGISConn"}},[_c('b-input-group',{attrs:{"size":"md","prepend":"Port"}},[_c('b-input',{attrs:{"type":"text","autocomplete":"false","disabled":_vm.isReadonly},model:{value:(_vm.connection.port),callback:function ($$v) {_vm.$set(_vm.connection, "port", $$v)},expression:"connection.port"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d01501d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/connection/POSTGISConnection.vue
// module id = null
// module chunks = 